import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import ModalContainer from './ModalContainer'
import WidgetContext from './WidgetContext'
import { buildApiClient } from '../../helpers/client'

const Widget2 = ({ host, apiKey, children }) => {
  const [ready, setReady] = useState(false)
  const [attributes, setAttributes] = useState({
    franchise: null,
    brand: null
  })
  const [franchise, setFranchise] = useState(null)
  const [brand, setBrand] = useState(null)
  const [unrecoverableError, _setUnrecoverableError] = useState(false)
  const [modalContainer, setModalContainer] = useState(null)
  const client = buildApiClient(apiKey)

  useEffect(() => {
    loadBrand()
  }, [])

  async function loadBrand() {
    try {
      const response = await  client.get(`${host}/api/v1/brand?include=franchise`)

      const brand = response.data.data
      const franchise = response.data.included.find(i => i.type === 'franchise')

      setAttributes({
        franchise,
        brand
      })
      setReady(true)
    }
    catch(error) {
      setUnrecoverableError(error)
    }
  }

  function setUnrecoverableError(error) {
    _setUnrecoverableError(true)
    console.error(error)
  }

  if(!ready) {
    return null
  }

  return (
    <div className="checkcherry__widget">
      <>
        { unrecoverableError ? (
          <div>
            <p style={styles.errorText}>An error occurred while loading this component.  Please refresh the page and try again.</p>
          </div>
        ) : (
          <WidgetContext.Provider value={{
            host,
            apiKey,
            client,
            franchise: attributes.franchise,
            brand: attributes.brand,
            setUnrecoverableError
          }}>
            { children }
          </WidgetContext.Provider>
        )}
      </>
      <ModalContainer
        onLoad={el => setModalContainer(el)}
        onUnload={() => setModalContainer(null)}
      />
    </div>
  )
}

const styles = {
  errorText: {
    textAlign: "center"
  }
}

export { WidgetContext }
export default Widget2
